import { Icons } from "@smile2impress/components";

export default (iconData: string | React.FunctionComponent) =>
    typeof iconData === "string"
        ? Icons[iconData as keyof typeof Icons]
        : iconData;
